import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import consentCodePrefixApi from '@/features/dashboard/consentCodePrefix/api/consentCodePrefixApi.ts';
import { consentCodePrefixApiQueryKeys } from '@/features/dashboard/consentCodePrefix/api/consentCodePrefixApi.queryKeys.ts';
import { ConsentCodePrefixDto } from '@/features/dashboard/consentCodePrefix/types/ConsentCodePrefixDto.ts';

const useGetConsentCodePrefix = () => {
  return useQuery(getConsentCodePrefixQueryOptions());
};

export const getConsentCodePrefixQueryOptions =
  (): UseQueryOptions<ConsentCodePrefixDto> => ({
    queryKey: consentCodePrefixApiQueryKeys.all(),
    queryFn: () => consentCodePrefixApi.get(),
    staleTime: 1000 * 60,
  });

export default useGetConsentCodePrefix;
